/**
 * Immutable PAYG pack table. The client names a pack; the price and the credit come
 * from here, never from a client-supplied amount. The pack id travels to the ITN in
 * custom_str4 so the full pack can be credited even when a coupon lowered the price.
 */
/** The pay-as-you-go rate in rand per hour, VAT inclusive. The one place the number is typed. */
export const PAYG_RATE_PER_HOUR_ZAR = 7.5;

export const PAYG_PACKS = {
  payg_r50:  { priceZar: 50 },
  payg_r100: { priceZar: 100 },
  payg_r200: { priceZar: 200 },
} as const;
export type PaygPackId = keyof typeof PAYG_PACKS;

export function isPaygPackId(id: unknown): id is PaygPackId {
  return typeof id === 'string' && Object.prototype.hasOwnProperty.call(PAYG_PACKS, id);
}
